import { PageHeader } from "../components/PageHeader";
import { ServiceCard } from "../components/ServiceCard";
import { Card, Lead, P } from "../components/Section";

export default function Marketing() {
  return (
    <div className="pb-10">
      <PageHeader
        eyebrow="Маркетинг-консалтинг"
        title="Выбери формат"
        subtitle="Один разбор на 90 минут — или системная стратегия для всей компании."
        icon="📈"
        iconColor="blue"
      />
      <div className="px-5 mt-3 space-y-3">
        <Card>
          <Lead>8 лет в маркетинге. Личный бренд с 90 000+ подписчиков, форумы до 7 000 участников.</Lead>
          <P>Помогаю с лидогенерацией, личным брендом, упаковкой продукта и запуском мероприятий — точечно или в формате полной стратегии.</P>
        </Card>

        <div className="ios-group">
          <ServiceCard to="/marketing/consultation"
            icon="📞"
            title="Разовая консультация"
            subtitle="90 минут Zoom — разбор узкого места"
            color="blue" />
          <ServiceCard to="/marketing/strategy"
            icon="📋"
            title="Маркетинг-стратегия"
            subtitle="4 встречи, документ по системе SOSTAC"
            color="purple" />
        </div>
      </div>
    </div>
  );
}
